import { callNotify } from "../../..";
import { nextPage } from "../../../util/library/Router";
import { CONTRACT_TYPE, OPERATION_TYPE, operationType, PATHNAME, TIME_PER_STEP } from "../../../util/varibles/constants";
import { checkLimit, escapeClassName, getElById } from "../../../util/varibles/global";
import { ISite, IUnit, IVessel } from "../../../util/varibles/interface";
import { notify, NotifyCode } from "../../../util/varibles/message";
import { CALENDAR_ID } from "../constants";
import { EL_RULE } from "../Plan/Calendar/constants";
import stylesContract from "../Plan/Calendar/Contracts/style.module.scss";
import { HEIGHT_PER_DAY } from "../Plan/Calendar/Operations/constants";
import styles from "../Plan/Calendar/Vessels/style.module.scss";
import { convertPxToTime } from "../util";

export const KEY_SPLIT = '_'

export enum MODE_DRAG {
    START = 'drag_start',
    END = 'drag_end',
    OVER = 'drag_over',
    DROP = 'drop'
}

export const filterOperationTypeOfVessel = (vessel: IVessel, limit: OPERATION_TYPE[] = []) => {
    const opType: Set<OPERATION_TYPE> = new Set(vessel.operation_type);
    const result = limit.length === 0 ? Array.from(opType) : limit.reduce((rs: OPERATION_TYPE[], item: OPERATION_TYPE) => {
        if (opType.has(item))
            return [...rs, item,]
        return rs;
    }, [])

    return result.sort((a: number, b: number) => a - b);
}

export const checkOperationType = (vessel: IVessel, limit: OPERATION_TYPE[] = []) => {
    const listOfType = filterOperationTypeOfVessel(vessel, limit);
    if (listOfType.length === 0)
        callNotify?.error({
            title: 'Error',
            description: `${vessel.name} does not support ${limit.map((item: any) => operationType[item].name).join(', ')}`
        })
    return listOfType
}

export const UnitModel = (unit: IUnit, site?: ISite): IUnit => {
    return {
        ...unit,
        site_id: site?.id,
        site_name: site?.name,
        site_type: site?.type,
        diseases: site?.diseases,
        primary_factory: site?.primary_factory
    }
}

const MIN_WIDTH = 800;

export const calculateWidth = () => {
    return Math.floor((window.innerWidth - 30) / MIN_WIDTH) || 1
};

export const deleteDragEl = (el: any) => {
    if (el)
        el.remove();
}

export const redirectCreateRoute = (planned: { site_id: string, factory_id: string }) => {
    const { site_id, factory_id } = planned;
    nextPage(`${PATHNAME.ROUTE}?source=${site_id}&destination=${factory_id}`, false)
}

interface IResultOfMouseDown {
    startTime: number
    operationId: string
    vessel: IVessel | undefined
    contractId: string
    availableTimeId: string
}

export const onMouseDown = (e: any, vessels: IVessel[], useDroppedStartTime = false): IResultOfMouseDown | undefined => {
    const { pageX, pageY } = e;
    const left = checkLimit(0, window.innerWidth, pageX);
    const top = checkLimit(0, window.innerHeight, pageY);
    let element: HTMLElement | any = document.elementFromPoint(left, top);

    if (!element) return;
    const { lineType } = element.dataset;

    if (lineType === 'date')
        element = document.elementFromPoint(left, top - 2)

    const params: IResultOfMouseDown = {
        startTime: Math.ceil(Date.now() / TIME_PER_STEP) * TIME_PER_STEP,
        operationId: '',
        vessel: undefined,
        contractId: '-',
        availableTimeId: '-'
    }
    let hideElements = [];
    const contractClass = escapeClassName(stylesContract.contract);
    if (element.closest(`.${contractClass}`)) {
        const { contractId, contractType, isOwn } = element.dataset;
        if (contractType === CONTRACT_TYPE.FIXED) {
            if (!isOwn) {
                notify.error(NotifyCode.E26)();
                return;
            } else {
                params.contractId = contractId;
            }
        }
        element.style.display = 'none';
        hideElements.push(element);
        element = document.elementFromPoint(left, top);
    }
    hideElements.forEach((item: any) => item.style.display = null);
    const { operationId = '', vesselId, availableTimeId, date } = element.dataset;
    if (operationId) {
        params.operationId = operationId;
    } else if (availableTimeId) {
        const { isRent } = element.dataset;
        if (isRent === 'true') {
            const { y } = element.getBoundingClientRect();
            const duration = convertPxToTime(e.pageY - y);
            params.vessel = vessels.find((item: any) => item.id === vesselId);
            params.availableTimeId = availableTimeId;
            const droppedTime = Math.ceil((Number(date) + duration) / TIME_PER_STEP) * TIME_PER_STEP;
            params.startTime = useDroppedStartTime
                ? droppedTime
                : Math.max(droppedTime, Math.ceil(Date.now() / TIME_PER_STEP) * TIME_PER_STEP);
        } else {
            notify.error(NotifyCode.E26)();
            return;
        }
    } else if (vesselId) {
        const { accessFull } = element.dataset;
        if (accessFull === 'true' || (accessFull === 'false' && params.contractId !== '-')) {
            params.vessel = vessels.find((item: any) => item.id === vesselId);
            if (date)
                params.startTime = Number(date);
            else {
                const vesselEL = getElById(`${EL_RULE.VESSEL}-${vesselId}`)
                if (vesselEL) {
                    const calendarEl = getElById(CALENDAR_ID);
                    const { y } = calendarEl.getBoundingClientRect();
                    const position = Math.floor((calendarEl.scrollTop + e.pageY - y) / HEIGHT_PER_DAY);
                    const daysEl = vesselEL.getElementsByClassName(styles.day)
                    const dayEl = daysEl[position] as HTMLElement;
                    if (dayEl) {
                        const { date } = dayEl.dataset;
                        params.startTime = useDroppedStartTime
                            ? Number(date)
                            : Math.max(Number(date), Math.ceil(Date.now() / TIME_PER_STEP) * TIME_PER_STEP);
                    } else
                        return;
                } else
                    return
            }
        } else {
            notify.error(NotifyCode.E26)();
            return;
        }
    }

    return params;
}
